import React, { useMemo } from 'react';
import { useT } from '@transifex/react';
import { FAQ } from '@raisin/components-lib';
import messages from '../messages';

const Faq: React.FC = () => {
  const t = useT();
  const topicId = 'topic1';

  const faqEntries = useMemo(
    () =>
      Object.keys(messages)
        .filter((key) => messages[key].startsWith('bankProductPage.faq.question'))
        .map((key, index) => {
          const currentFAQIndex = index + 1;
          const question = t(messages[key]);
          const answer = t(messages[`bankFaqAnswer${currentFAQIndex}`]);
          const answerLinkKey = `bankFaqAnswer${currentFAQIndex}Link`;
          const answerLink = Object.prototype.hasOwnProperty.call(messages, answerLinkKey)
            ? t(messages[answerLinkKey])
            : '';
          const answerWithLink = answer.replace('<a>', `<a href="${answerLink}" target="_blank">`);

          return {
            _metadata: {
              uid: `faq${currentFAQIndex}`,
            },
            faq: {
              question,
              answer: answerWithLink,
              text_link: null,
              topic_id: topicId,
            },
          };
        }),
    [t],
  );

  return (
    <FAQ
      faq_entries={faqEntries}
      headline={t(messages.bankFaqHeadline)}
      topics={[
        {
          topic: {
            is_default: true,
            text: topicId,
            topic_id: topicId,
          },
        },
      ]}
    />
  );
};

export default Faq;
